var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#fff",
    stroke: "#999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M9 7V4a1 1 0 1 0-2 0v5h5a1 1 0 0 0 0-2zm-1 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2M4 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
  })));
};
export default SvgClockIcon;